<template>
  <router-view/>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class Main extends Vue {
    
    async created(){
        
    }
}
</script>
<style>
/* Vue1.1 */
.v-menu__activator {
	height: auto !important;
}
#inspire > div > main > div.v-content__wrap {display:flex;}

/* Vue2.0 */
.v-expansion-panels.v-item-group{
  position:inherit;
}
.v-expansion-panel-content__wrap{
  padding-bottom: 0px;
}
.v-card__text{
  color:inherit !important;
}
.v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,
.v-input--selection-controls .v-input--selection-controls__input:hover .v-input--selection-controls__ripple::before {
  background: none;
  outline: solid #273474 3px;
  transform: scale(0.9);
  opacity: 1;
}

.v-input--selection-controls__ripple > .v-ripple__container {
  transform: scale(0.9);
}

.visually-hidden {
    position: absolute !important;
    height: 1px; 
    width: 1px; 
    overflow: hidden;
    padding: 0 !important;
    border: 0! important;
    white-space: nowrap !important;
    clip: rect(1px 1px 1px 1px) !important; /* IE6, IE7 */
    clip: rect(1px, 1px, 1px, 1px) !important;
    clip-path: inset(50%) !important;
}
</style>
